import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PRODUCTS } from "@/lib/content";

export default function Products() {
  return (
    <div className="mx-auto max-w-7xl px-6 lg:px-14 pt-10 pb-24">
      <div className="max-w-2xl">
        <div className="overline text-cobalt-500">The Arventiq family</div>
        <h1 className="mt-2 font-display text-4xl sm:text-5xl font-black tracking-tighter">
          One lab. A whole campus stack.
        </h1>
        <p className="mt-4 text-lg text-muted-foreground">
          The events platform is part of a suite of secure, India-first products built by Arventiq Labs for institutions.
        </p>
      </div>

      <div className="mt-10 grid sm:grid-cols-2 gap-5">
        {PRODUCTS.map((p, i) => (
          <motion.a
            key={p.name}
            href={p.url}
            target="_blank"
            rel="noreferrer"
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.05 }}
            className="glass rounded-2xl p-6 group hover:-translate-y-1 transition-transform block relative overflow-hidden"
          >
            <div className="absolute -top-12 -right-12 h-32 w-32 rounded-full bg-cobalt-500/10 blur-2xl opacity-60" />
            <div className="relative">
              <div className="flex items-center gap-2">
                <span className="text-[10px] font-mono uppercase tracking-widest px-2 py-0.5 rounded-full bg-cobalt-500/10 text-cobalt-500">Live</span>
                <span className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground">{p.tag}</span>
                <ArrowUpRight className="h-4 w-4 ml-auto opacity-40 group-hover:opacity-100 transition-opacity" />
              </div>
              <h3 className="mt-3 font-display text-2xl font-extrabold tracking-tighter">{p.name}</h3>
              <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{p.desc}</p>
            </div>
          </motion.a>
        ))}
      </div>

      <div className="mt-14 glass-strong rounded-3xl p-10 lg:p-12 text-center relative overflow-hidden">
        <div className="absolute -top-20 -right-20 h-60 w-60 rounded-full bg-cyant-400/30 blur-3xl opacity-40" />
        <div className="relative">
          <h2 className="font-display text-2xl sm:text-3xl font-black tracking-tighter">
            Want the events platform for your campus?
          </h2>
          <p className="mt-3 text-muted-foreground max-w-xl mx-auto">
            Talk to Arventiq Labs about bringing the full stack — events, service desk, exams, LMS, placements — to your institution.
          </p>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
            <Link to="/contact">
              <Button
                size="lg"
                className="rounded-full font-medium h-11 px-6 bg-zinc-900 hover:bg-zinc-800 dark:bg-white dark:text-zinc-900 dark:hover:bg-zinc-100"
              >
                Request a demo <ArrowUpRight className="ml-1.5 h-4 w-4" />
              </Button>
            </Link>
            <a
              href="https://arventiqlabs.com"
              target="_blank"
              rel="noreferrer"
            >
              <Button variant="outline" size="lg" className="rounded-full font-medium h-11 px-6">
                About Arventiq Labs <ArrowUpRight className="ml-1.5 h-4 w-4" />
              </Button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
